(() => {
  if (window.TMWheelVisit) return;
  const LEGACY_KEY = 'tmWheelCartEnteredV1';
  const JOURNEY_KEY = 'tmWheelCartJourneyV2';
  const cartPath = path => /(?:^|\/)(?:cart)(?:\/|$)/.test(path);
  const checkoutPath = path => /(?:^|\/)(?:checkout|checkouts)(?:\/|$)/.test(path);
  const emptyState = () => ({ enteredAt: 0, checkoutStartedAt: 0, recoveryShownAt: 0 });
  const readState = () => {
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(JOURNEY_KEY) || "null");
      return parsed && typeof parsed === "object" ? { ...emptyState(), ...parsed } : emptyState();
    } catch { return emptyState(); }
  };
  const writeState = value => {
    try { window.sessionStorage.setItem(JOURNEY_KEY, JSON.stringify(value)); } catch {}
    return value;
  };
  const announce = (name, state) => document.dispatchEvent(new CustomEvent(name, { detail: { ...state } }));
  const markCart = () => {
    const state = readState();
    if (!Number(state.enteredAt)) {
      state.enteredAt = Date.now();
      state.checkoutStartedAt = 0;
      state.recoveryShownAt = 0;
      writeState(state);
    }
    try { window.sessionStorage.setItem(LEGACY_KEY, '1'); } catch {}
    announce('tm:wheel-cart-entered', state);
    return state;
  };
  const markCheckout = () => {
    const state = readState();
    if (!Number(state.enteredAt)) state.enteredAt = Date.now();
    state.checkoutStartedAt = Date.now();
    writeState(state);
    announce('tm:wheel-checkout-started', state);
    return state;
  };
  const markRecoveryShown = () => {
    const state = readState();
    state.recoveryShownAt = Date.now();
    return writeState(state);
  };
  window.TMWheelVisit = {
    get cartEntered() { return Number(readState().enteredAt) > 0; },
    get checkoutStarted() { return Number(readState().checkoutStartedAt) > 0; },
    get cartReturnEligible() {
      const state = readState();
      return Number(state.enteredAt) > 0 && Number(state.checkoutStartedAt) < 1 && Number(state.recoveryShownAt) < 1;
    },
    get state() { return readState(); },
    markCart,
    markCheckout,
    markRecoveryShown
  };
  const checkRoute = () => {
    if (checkoutPath(window.location.pathname)) markCheckout();
    else if (cartPath(window.location.pathname) || document.querySelector('cart-drawer.active, #cart-notification.active, .tm-cart-notification-open')) markCart();
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target?.closest?.('a[href]');
    if (!link || link.closest('[data-tm-exit-wheel]') || (link.target && link.target !== '_self')) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (checkoutPath(url.pathname)) markCheckout();
      else if (cartPath(url.pathname)) markCart();
    } catch {}
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') { markCheckout(); return; }
    try {
      const url = new URL(event.target.action, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (checkoutPath(url.pathname)) markCheckout();
      else if (cartPath(url.pathname) && !url.pathname.endsWith('/add')) markCart();
    } catch {}
  }, true);
  const observeCart = () => {
    checkRoute();
    const observer = new MutationObserver(checkRoute);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('cart-drawer, #cart-notification').forEach(node => observer.observe(node, { attributes: true, attributeFilter: ['class'] }));
  };
  window.addEventListener('pageshow', checkRoute);
  window.addEventListener('popstate', checkRoute);
  document.addEventListener('cart:open', markCart);
  document.addEventListener('cart:opened', markCart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeCart, { once: true });
  else observeCart();
  checkRoute();
})();
(() => {
  const serviceDiagnostic = (stage, status = 0, error = '') => {
    document.documentElement.dataset.tmOfferServiceStage = stage;
    document.documentElement.dataset.tmOfferServiceStatus = status ? String(status) : '';
    document.documentElement.dataset.tmOfferServiceError = error;
  };
  if (window.TMCartOfferReservation) {
    if (!window.TMPrivateOffers) serviceDiagnostic('unavailable', 0, 'bridge_unavailable');
    return;
  }
  serviceDiagnostic('initialized');
  const NATIVE_KEY = 'tmNativeWheelOfferV2';
  const HERITAGE_KEY = 'tmWheelHeritageHoldV1';
  const HOLD_DURATION = 15 * 60 * 1000;
  const RETURN_REWARD_DELAY = 24 * 60 * 60 * 1000;
  const WHEEL_KEY = 'tmHesitationWheelReservation';
  const ROOT = '[data-tm-offer-timer]:has([data-tm-offer-clock])';
  const WELCOME = 'WELCOME15';
  const WELCOME_HOLD_KEY = 'tmWelcomeOfferHoldV1';

  const locale = (document.documentElement.lang || 'en').split('-')[0];
  const strings = {
    en: { title: '15% off your first order', copy: 'Your welcome offer.', applied: 'Your 15% saving is included.', label: 'Bonus ends in', offerLabel: 'Offer ends in', holdLabel: 'Cart offer ends in', wheel: 'Your private offer', wheelCopy: 'Your offer is ready.', wheelApplied: 'Your saving is included.', selected: 'Your selected discount', selectedCopy: 'Your current discount stays with your cart.', gift: 'Mystery Vibrator', giftIncluded: 'Gift included', giftReady: 'Your gift is ready.', cart: 'Your cart', reassurance: 'Discreet packaging · 30-day free returns' },
    de: { title: '15 % auf deine erste Bestellung', copy: 'Dein Willkommensangebot.', applied: 'Deine 15 % Ersparnis sind enthalten.', label: 'Bonus endet in', offerLabel: 'Angebot endet in', holdLabel: 'Warenkorbangebot endet in', wheel: 'Dein persönliches Angebot', wheelCopy: 'Dein Angebot ist bereit.', wheelApplied: 'Deine Ersparnis ist enthalten.', selected: 'Dein gewählter Rabatt', selectedCopy: 'Dein aktueller Rabatt bleibt im Warenkorb.', gift: 'Überraschungsvibrator', giftIncluded: 'Geschenk enthalten', giftReady: 'Dein Geschenk ist bereit.', cart: 'Dein Warenkorb', reassurance: 'Diskrete Verpackung · 30 Tage kostenlose Rückgabe' },
    fr: { title: '15 % sur votre première commande', copy: 'Votre offre de bienvenue.', applied: 'Votre réduction de 15 % est incluse.', label: 'Bonus valable encore', offerLabel: 'Offre valable encore', holdLabel: 'Offre du panier valable encore', wheel: 'Votre offre privée', wheelCopy: 'Votre offre est prête.', wheelApplied: 'Votre réduction est incluse.', selected: 'Votre réduction choisie', selectedCopy: 'Votre réduction actuelle reste dans votre panier.', gift: 'Vibromasseur surprise', giftIncluded: 'Cadeau inclus', giftReady: 'Votre cadeau est prêt.', cart: 'Votre panier', reassurance: 'Emballage discret · Retours gratuits sous 30 jours' },
    es: { title: '15 % en tu primer pedido', copy: 'Tu oferta de bienvenida.', applied: 'Tu ahorro del 15 % está incluido.', label: 'El bono termina en', offerLabel: 'La oferta termina en', holdLabel: 'La oferta del carrito termina en', wheel: 'Tu oferta privada', wheelCopy: 'Tu oferta está lista.', wheelApplied: 'Tu ahorro está incluido.', selected: 'Tu descuento elegido', selectedCopy: 'Tu descuento actual sigue en el carrito.', gift: 'Vibrador sorpresa', giftIncluded: 'Regalo incluido', giftReady: 'Tu regalo está listo.', cart: 'Tu carrito', reassurance: 'Embalaje discreto · Devoluciones gratuitas de 30 días' }
  };
  const copy = strings[locale] || strings.en;
  let cart = null;
  let cartRevision = 0;
  let refreshAfterRequest = false;
  let request = null;
  let checkoutRequest = null;
  let syncTimer = 0;
  let subscribed = false;
  let welcomeAttemptedFor = '';
  let welcomeUnavailableFor = '';
  let session = null;
  let serviceReady = true;
  let claimRequest = null;
  let memoryOffer = null;
  let deadlineRefreshed = 0;
  const cartEventName = () => window.PUB_SUB_EVENTS?.cartUpdate || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null);
  const rootUrl = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const roots = () => [...document.querySelectorAll(ROOT)];
  const normalizeCode = value => String(value || '').trim().toUpperCase();
  const get = key => {
    try { const value = window.localStorage.getItem(key); if (value) return value; } catch {}
    if (key === HERITAGE_KEY) { try { const cookie = document.cookie.split('; ').find(value => value.startsWith(key + '=')); return cookie ? decodeURIComponent(cookie.slice(key.length + 1)) : null; } catch {} }
    return null;
  };
  const read = key => { try { return JSON.parse(get(key) || 'null'); } catch { return null; } };
  const clockStart = Date.now();
  const performanceStart = window.performance?.now?.() || 0;
  const now = () => Math.max(Date.now(), clockStart + Math.max(0, (window.performance?.now?.() || 0) - performanceStart));
  const PRIZES = [
    { code: 'TMPRIVATE3', title: '17% off', kind: 'discount', percent: 17, angle: 275.4 },
    { code: 'TMMYSTERYVIBE', title: 'Mystery gift', kind: 'gift', percent: 0, angle: 185.4, permanentGift: true },
    { code: 'TMPRIVATE5', title: '18% off', kind: 'discount', percent: 18, angle: 135 },
    { code: 'TMPLUS5', title: '20% off', kind: 'discount', percent: 20, angle: 45 }
  ].map(prize => Object.freeze({ ...prize, nativeShopify: true, serverEnforced: false, expiresAt: null }));
  const nativeOffer = candidate => {
    if (!candidate || candidate.nativeShopify !== true || candidate.serverEnforced !== false) return null;
    const prize = PRIZES.find(item => item.code === normalizeCode(candidate.code) && item.kind === candidate.kind && item.percent === candidate.percent);
    if (!prize) return null;
    if (candidate.browserTimed === true) {
      if (!Number.isFinite(candidate.awardedAt) || candidate.awardedAt <= 0 || candidate.expiresAt !== candidate.awardedAt + HOLD_DURATION
        || (candidate.kind === 'gift' && candidate.permanentGift !== false)) return null;
      return Object.freeze({ ...prize, browserTimed: true, awardedAt: candidate.awardedAt, expiresAt: candidate.expiresAt,
        ...(candidate.kind === 'gift' ? { permanentGift: false } : {}) });
    }
    return candidate.expiresAt === null ? prize : null;
  };
  const expiredOffer = offer => (offer?.browserTimed === true || offer?.serverEnforced === true)
    && offer.permanentGift !== true && Number.isFinite(offer.expiresAt) && offer.expiresAt <= now();
  const existingOffer = () => {
    const current = nativeOffer(read(HERITAGE_KEY));
    if (current?.browserTimed === true) return current;
    if (memoryOffer) return memoryOffer;
    const saved = read(WHEEL_KEY);
    const native = nativeOffer(saved);
    if (native?.browserTimed === true) return native;
    if (saved?.kind === 'gift' && normalizeCode(saved.code) === 'TMMYSTERYVIBE' && saved.browserTimed !== true) return PRIZES[1];
    if (saved?.serverClaimed === true && saved.serverEnforced === true && saved.kind === 'discount'
      && /^TMX-[A-F0-9]{32}$/.test(normalizeCode(saved.code)) && [17, 18, 20].includes(saved.percent)
      && Number.isFinite(saved.expiresAt) && saved.expiresAt > 0) {
      const prize = PRIZES.find(item => item.kind === 'discount' && item.percent === saved.percent);
      return Object.freeze({ ...prize, code: normalizeCode(saved.code), nativeShopify: false, serverEnforced: true, expiresAt: saved.expiresAt });
    }
    const oldNative = nativeOffer(read(NATIVE_KEY));
    return oldNative?.kind === 'gift' && oldNative.browserTimed !== true ? oldNative : null;
  };
  const notifySession = () => {
    document.dispatchEvent(new CustomEvent('tm:private-offer-session', { detail: { session, ready: serviceReady } }));
    render();
  };
  const canReactivate = offer => Boolean(offer?.nativeShopify === true && offer.browserTimed === true
    && nativeOffer(offer) && expiredOffer(offer) && now() - offer.awardedAt >= RETURN_REWARD_DELAY);
  const setSession = offer => {
    const expired = expiredOffer(offer);
    if (canReactivate(offer)) {
      session = Object.freeze({ state: 'available', expiresAt: null, serverNow: now(), renewableOffer: offer });
      serviceReady = true;
      serviceDiagnostic('shopify-native-ready');
      notifySession();
      return session;
    }
    session = Object.freeze({ state: expired ? 'expired' : offer ? 'claimed' : 'available', expiresAt: offer?.expiresAt ?? null, serverNow: now(), ...(offer ? { offer } : {}) });
    serviceReady = true;
    serviceDiagnostic('shopify-native-ready');
    notifySession();
    return session;
  };
  const ensureSession = (options = {}) => {
    if (claimRequest) return claimRequest;
    if (expiredOffer(session?.offer)) return Promise.resolve(setSession(session.offer));
    if (session && !options.refresh) return Promise.resolve(session);
    return Promise.resolve(setSession(existingOffer()));
  };
  const claim = () => {
    if (claimRequest) return claimRequest;
    const award = async () => {
      const existing = existingOffer() || session?.offer;
      if (existing && !canReactivate(existing)) return setSession(existing);
      if (existing) await window.TMWheelCart?.cleanupExpiredOffer?.({ force: true });
      const random = window.crypto?.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296 : Math.random();
      const prize = existing ? PRIZES.find(item => item.code === existing.code)
        : PRIZES[random < 0.47 ? 0 : random < 0.50 ? 1 : random < 0.75 ? 2 : 3];
      const awardedAt = now();
      memoryOffer = Object.freeze({ ...prize, browserTimed: true, awardedAt, expiresAt: awardedAt + HOLD_DURATION, ...(prize.kind === 'gift' ? { permanentGift: false } : {}) });
      try { window.localStorage.setItem(HERITAGE_KEY, JSON.stringify(memoryOffer)); } catch {}
      try { document.cookie = HERITAGE_KEY + '=' + encodeURIComponent(JSON.stringify(memoryOffer)) + '; Path=/; Max-Age=2592000; SameSite=Lax; Secure'; } catch {}
      window.TMWheelJourney?.track('tm_wheel_reward_activated', { renewed: Boolean(existing), rewardKind: prize.kind, rewardPercent: prize.percent });
      return setSession(memoryOffer);
    };
    claimRequest = (window.navigator.locks?.request
      ? window.navigator.locks.request('tm-wheel-award-v4', award) : Promise.resolve().then(award))
      .finally(() => { claimRequest = null; });
    return claimRequest;
  };
  window.TMPrivateOffers = { ensureSession, claim, getSession: () => session, now, get ready() { return serviceReady; } };

  const applications = value => [
    ...(value?.cart_level_discount_applications || []),
    ...(value?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
  ];
  const rejectedCode = (value, code) => (value?.discount_codes || []).some(item =>
    item && typeof item === 'object' && normalizeCode(item.code) === code && item.applicable === false);
  const expiredPrivateCode = code => session?.offer?.code === code && expiredOffer(session.offer);
  const discountCodes = (value = cart) => {
    const codes = (value?.discount_codes || [])
      .filter(item => item && typeof item === 'object' && item.applicable === true)
      .map(item => normalizeCode(item.code)).filter(Boolean);
    applications(value).forEach(item => {
      if (!item?.title) return;
      const title = normalizeCode(item.title);
      if (item.type === 'discount_code') codes.push(title);
      else if (title.replace(/[^A-Z0-9]/g, '') === 'WELCOME15OFF') codes.push(WELCOME);
    });
    const automaticWelcome = applications(value).some(item => (item?.type === 'automatic' || (item?.type === '' && Number(item.total_allocated_amount) > 0)) && normalizeCode(item.title).replace(/[^A-Z0-9]/g, '') === 'WELCOME15OFF');
    return [...new Set(codes)].filter(code => (!rejectedCode(value, code) || (code === WELCOME && automaticWelcome)) && !expiredPrivateCode(code));
  };
  const protectedCodes = (value = cart) => {
    // Preserve unconfirmed submitted codes too: absence of proof is not permission to replace them.
    const codes = (value?.discount_codes || []).filter(item => typeof item === 'string' || item?.applicable !== false)
      .map(item => normalizeCode(typeof item === 'string' ? item : item?.code)).filter(Boolean);
    return [...new Set([...codes, ...discountCodes(value)])].filter(code => !expiredPrivateCode(code));
  };
  const welcomeDeadline = () => 0;
  const activeServerOffer = () => serviceReady && session?.state === 'claimed'
    && !expiredOffer(session.offer) && (session.offer?.nativeShopify === true || session.offer?.permanentGift || session.offer?.expiresAt > now()) ? session.offer : null;
  const state = () => {
    const codes = discountCodes();
    const offer = activeServerOffer();
    if (offer) return {
      kind: 'wheel', offerKind: offer.kind, code: offer.code,
      title: offer.kind === 'gift' ? copy.gift : offer.title,
      deadline: offer.browserTimed === true || offer.kind === 'discount' ? offer.expiresAt : 0,
      sessionState: 'claimed', applied: codes.includes(offer.code), serverEnforced: offer.serverEnforced, browserTimed: offer.browserTimed === true
    };
    const other = codes.filter(code => code !== WELCOME);
    const base = other.length ? { kind: 'other', code: other.join(' · '), applied: true }
      : !codes.includes(WELCOME) && (rejectedCode(cart, WELCOME) || (cart && welcomeUnavailableFor === welcomeFingerprint(cart))) ? { kind: 'standard', code: '', applied: false }
      : { kind: 'welcome', code: WELCOME, applied: codes.includes(WELCOME) };
    const available = serviceReady && session?.state === 'available' && session.expiresAt > now();
    const welcomeHold = base.kind === 'welcome' && base.applied ? welcomeDeadline() : 0;
    return { ...base, deadline: welcomeHold || (available ? session.expiresAt : 0), sessionState: serviceReady ? session?.state : null,
      serverEnforced: Boolean(available), browserTimed: welcomeHold > 0 };
  };
  const text = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element && element.textContent !== value) element.textContent = value;
  };
  const format = deadline => {
    const seconds = Math.max(0, Math.ceil((deadline - now()) / 1000));
    return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
  };
  const syncCheckout = () => {
    document.querySelectorAll('[data-tm-cart-checkout]').forEach(link => {
      link.href = link.dataset.tmDefaultHref || rootUrl() + 'checkout';
    });
    const useWelcome = discountCodes().includes(WELCOME) && !protectedCodes().some(code => code !== WELCOME);
    document.querySelectorAll('input[name="discount"]').forEach(input => {
      if (normalizeCode(input.value) === WELCOME || input.dataset.tmOfferManaged === 'true') {
        input.dataset.tmOfferManaged = 'true';
        input.disabled = !useWelcome;
      }
    });
  };
  const render = () => {
    const current = state();
    const gift = current.kind === 'wheel' && current.offerKind === 'gift';
    const timed = current.kind === 'wheel' && (current.serverEnforced || current.browserTimed) && current.deadline > now();
    const savingIncluded = Number(cart?.total_discount) > 0 || Number(cart?.original_total_price) > Number(cart?.total_price);
    const blocks = roots();
    blocks.forEach(root => {
      const popup = Boolean(root.closest('cart-notification, cart-drawer'));
      root.hidden = (!timed && !savingIncluded) || !Number(cart?.item_count) || (popup && !savingIncluded);
      root.dataset.tmOfferTimed = String(timed);
      root.dataset.tmOfferState = current.kind;
      root.dataset.tmOfferSessionState = current.sessionState || 'unavailable';
      text(root, '[data-tm-offer-code]', current.kind === 'wheel' ? copy.wheel : current.code);
      text(root, '[data-tm-offer-title]', current.kind === 'wheel' ? current.title : current.kind === 'other' ? copy.selected : current.kind === 'standard' ? copy.cart : copy.title);
      text(root, '[data-tm-offer-copy]', gift ? (current.applied ? copy.giftIncluded : copy.giftReady)
        : current.kind === 'wheel' ? (current.applied ? copy.wheelApplied : copy.wheelCopy)
          : current.kind === 'other' ? copy.selectedCopy : current.kind === 'standard' ? copy.reassurance : current.applied ? copy.applied : copy.copy);
      text(root, '[data-tm-offer-label]', timed ? (current.browserTimed ? copy.holdLabel : current.sessionState === 'claimed' ? copy.offerLabel : copy.label) : '');
      text(root, '[data-tm-offer-clock]', timed ? format(current.deadline) : '');
      if (!timed && savingIncluded) text(root, '[data-tm-offer-copy]', copy.wheelApplied);
      const clock = root.querySelector('[data-tm-offer-clock]');
      if (clock) { clock.hidden = !timed; clock.setAttribute('aria-live', 'off'); }
      const label = root.querySelector('[data-tm-offer-label]');
      if (label) label.hidden = !timed;
      const renew = root.querySelector('[data-tm-offer-renew]');
      if (renew) { renew.hidden = true; renew.disabled = true; }
    });
    document.querySelectorAll('[data-tm-cart-offer]').forEach(old => { if (blocks.length) { old.hidden = true; old.style.display = 'none'; } });
    syncCheckout();
  };
  const sectionTargets = () => {
    const targets = [];
    ['main-cart-items', 'main-cart-footer'].forEach(id => {
      const element = document.getElementById(id);
      if (element?.dataset.id) targets.push({ id, section: element.dataset.id, selector: '.js-contents' });
    });
    const localized = document.querySelector('[data-tm-localized-cart]')?.closest('.shopify-section');
    if (localized?.id) targets.push({ id: localized.id, section: localized.id.replace(/^shopify-section-/, ''), localized: true });
    if (document.getElementById('cart-notification-product')) targets.push({ id: 'cart-notification-product', section: 'cart-notification-product', selector: '.tm-cart-notification-list', targetSelector: null });
    if (document.getElementById('cart-icon-bubble')) targets.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section', targetSelector: null });
    return targets.slice(0, 5);
  };
  const renderSections = value => {
    if (!value.sections) return;
    sectionTargets().forEach(target => {
      const html = value.sections[target.section];
      if (!html) return;
      const source = new DOMParser().parseFromString(html, 'text/html');
      const element = document.getElementById(target.id);
      if (!element) return;
      if (target.localized) {
        const summary = element.querySelector('.tm-l10n-cart__total');
        const updated = source.querySelector('.tm-l10n-cart__total');
        if (summary && updated) summary.innerHTML = updated.innerHTML;
        const prices = source.querySelectorAll('.tm-l10n-cart__item-copy > strong');
        element.querySelectorAll('.tm-l10n-cart__item-copy > strong').forEach((price, index) => { if (prices[index]) price.innerHTML = prices[index].innerHTML; });
      } else {
        const from = source.querySelector(target.selector);
        const to = target.targetSelector === null ? element : element.querySelector(target.selector);
        if (from && to) to.innerHTML = from.innerHTML;
      }
    });
  };
  const completeCart = value => Array.isArray(value?.items) && Number.isFinite(value.total_price) && Boolean(value.currency);
  const renderTotals = value => {
    if (!completeCart(value)) return;
    try {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: value.currency });
      const money = formatter.format(value.total_price / 100);
      document.querySelectorAll('#main-cart-footer .totals__total-value, .tm-l10n-cart__total > strong, #CartDrawer .totals__total-value, [data-tm-cart-total]').forEach(total => { if (total.textContent !== money) total.textContent = money; });
      document.querySelectorAll('[data-tm-cart-summary]').forEach(summary => { summary.hidden = !Number(value.item_count); });
      document.querySelectorAll('[data-tm-cart-line-key]').forEach(row => {
        const price = row.querySelector('[data-tm-cart-line-price]');
        if (!price) return;
        const exact = value.items.find(item => item.key === row.dataset.tmCartLineKey);
        const candidates = value.items.filter(item => String(item.variant_id) === row.dataset.tmCartVariantId);
        const item = exact || (candidates.length === 1 ? candidates[0] : null);
        price.hidden = !Number.isFinite(item?.final_line_price);
        if (!price.hidden) { const lineMoney = formatter.format(item.final_line_price / 100); if (price.textContent !== lineMoney) price.textContent = lineMoney; }
        const original = row.querySelector('[data-tm-cart-original-line-price]');
        if (original) {
          original.hidden = !Number.isFinite(item?.original_line_price) || !Number.isFinite(item?.final_line_price) || !(item.original_line_price > item.final_line_price);
          if (!original.hidden) { const originalMoney = formatter.format(item.original_line_price / 100); if (original.textContent !== originalMoney) original.textContent = originalMoney; }
        }
      });
    } catch {}
  };
  const acceptCart = value => {
    if (!completeCart(value)) return false;
    cart = value;
    if (!Number(value.item_count)) { try { window.sessionStorage.removeItem(WELCOME_HOLD_KEY); } catch {} }
    cartRevision++;
    refreshAfterRequest = false;
    renderTotals(value);
    return true;
  };
  const invalidateCart = () => {
    cartRevision++;
    if (request) refreshAfterRequest = true;
  };
  const cartRequest = async body => {
    const sections = body ? sectionTargets().map(target => target.section) : [];
    const response = await fetch(rootUrl() + (body ? 'cart/update.js' : 'cart.js'), {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify({ ...body, ...(sections.length ? { sections, sections_url: window.location.pathname } : {}) }) } : {})
    });
    if (!response.ok) throw new Error('Offer update failed');
    return response.json();
  };
  const changed = value => {
    renderSections(value);
    acceptCart(value);
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: value, source: 'tm-offer-reservation' } }));
    if (typeof window.publish === 'function' && cartEventName()) window.publish(cartEventName(), { source: 'tm-offer-reservation', cartData: value });
  };
  const welcomeFingerprint = value => JSON.stringify([
    value.currency, (value.items || []).map(item => [item.key || item.variant_id, item.quantity]),
    (value.discount_codes || []).filter(item => normalizeCode(typeof item === 'string' ? item : item?.code) !== WELCOME)
      .map(item => typeof item === 'string' ? item : [item.code, item.applicable])
  ]);
  const restoreWelcome = async value => {
    if (session?.offer?.browserTimed === true && expiredOffer(session.offer)) return value;
    if (!Number(value.item_count) || claimRequest || activeServerOffer()
      || protectedCodes(value).some(code => code !== WELCOME)
      || discountCodes(value).includes(WELCOME) || rejectedCode(value, WELCOME)) return value;
    const fingerprint = welcomeFingerprint(value);
    if (welcomeAttemptedFor === fingerprint) return value;
    welcomeAttemptedFor = fingerprint;
    const startedAtRevision = cartRevision;
    const updated = await cartRequest({ discount: WELCOME });
    if (startedAtRevision !== cartRevision) { schedule(); return cart; }
    // Shopify's applicability/allocation response, not a successful HTTP request, proves a saving.
    welcomeUnavailableFor = discountCodes(updated).includes(WELCOME) ? '' : fingerprint;
    changed(updated);
    return updated;
  };
  const sync = () => {
    if (request) return request;
    request = (async () => {
      const startedAtRevision = cartRevision;
      const value = await cartRequest();
      if (startedAtRevision !== cartRevision || !completeCart(value)) return cart;
      acceptCart(value);
      if (Number(cart.item_count)) void ensureSession();
      await restoreWelcome(cart);
      return cart;
    })().catch(() => cart).finally(() => {
      request = null;
      render();
      if (refreshAfterRequest) { refreshAfterRequest = false; schedule(); }
    });
    return request;
  };
  const schedule = () => { window.clearTimeout(syncTimer); syncTimer = window.setTimeout(sync, 120); };
  const bindCart = () => {
    if (subscribed || typeof window.subscribe !== 'function' || !cartEventName()) return;
    window.subscribe(cartEventName(), event => {
      if (event.source === 'tm-offer-reservation') return;
      if (!acceptCart(event.cartData)) invalidateCart();
      render(); schedule();
    });
    subscribed = true;
  };
  const renewWelcome = async () => { await sync(); return discountCodes().includes(WELCOME); };
  // The cart already holds its verified discounts; a checkout redirect must not replace them.
  const checkoutUrl = (destination = rootUrl() + 'checkout') => destination;
  const checkoutRetry = () => {
    const message = ({ en: 'Please try checkout again.', de: 'Bitte versuche es erneut.', fr: 'Veuillez réessayer de passer au paiement.', es: 'Vuelve a intentar el pago.' })[locale] || 'Please try checkout again.';
    const controls = 'button[name="checkout"], input[name="checkout"], [data-tm-cart-checkout]';
    document.querySelectorAll(controls).forEach(control => {
      control.removeAttribute('aria-busy');
      if (control.dataset.tmOriginalText) {
        if (control.matches('input')) control.value = control.dataset.tmOriginalText;
        else control.textContent = control.dataset.tmOriginalText;
      }
    });
    const wheelCopy = document.querySelector('[data-tm-exit-wheel]:not([hidden]) [data-tm-wheel-result-copy]');
    if (wheelCopy) { wheelCopy.textContent = message; return; }
    let notice = document.querySelector('[data-tm-checkout-retry]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-tm-checkout-retry', '');
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'margin:10px 0 0;font-size:16px;line-height:1.4;color:#692b41;';
      const control = document.activeElement?.closest?.(controls) || document.querySelector(controls);
      (control?.parentElement || document.querySelector('main') || document.body).appendChild(notice);
    }
    notice.textContent = message;
    notice.hidden = false;
  };
  const checkout = (destination = rootUrl() + 'checkout') => {
    if (checkoutRequest) return checkoutRequest;
    checkoutRequest = Promise.resolve().then(async () => {
      const notice = document.querySelector('[data-tm-checkout-retry]');
      if (notice) notice.hidden = true;
      await ensureSession({ refresh: true });
      const guard = window.TMPrivateOfferGiftCheckout;
      if (typeof guard === 'function') {
        if (await guard(cart) !== true) { checkoutRetry(); return false; }
      } else if (session?.offer?.browserTimed === true || (cart?.items || []).some(item => item.properties?._tm_wheel_gift === 'Mystery Vibrator')) {
        checkoutRetry();
        return false;
      }
      window.TMWheelVisit?.markCheckout?.();
      window.TMWheelJourney?.markCheckout();
      window.TMWheelJourney?.track('tm_wheel_checkout_handoff', { rewardApplied: Boolean(activeServerOffer() && discountCodes().includes(activeServerOffer().code)), rewardKind: activeServerOffer()?.kind || null });
      window.location.assign(checkoutUrl(destination));
      return true;
    }).catch(() => { checkoutRetry(); return false; }).finally(() => { checkoutRequest = null; });
    return checkoutRequest;
  };
  window.TMCartOfferReservation = { getCart: () => cart, sync, render, state, renewWelcome, welcomeDeadline, discountCodes, checkoutUrl, checkout, strings };
  window.__tmCartOfferTimer = () => { invalidateCart(); render(); schedule(); };
  document.addEventListener('click', event => {
    const candidate = event.target.closest?.('a[href]');
    let checkoutLink = null;
    if (candidate) { try { const target = new URL(candidate.href, window.location.href); if (target.origin === window.location.origin && /(?:^|\/)checkout(?:\/|$)/.test(target.pathname)) checkoutLink = candidate; } catch {} }
    const link = event.target.closest?.('[data-tm-cart-checkout]') || checkoutLink;
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      checkout(link.dataset.tmDefaultHref || (checkoutLink ? checkoutLink.href : rootUrl() + 'checkout'));
    }
  });
  document.addEventListener('submit', event => {
    if (event.defaultPrevented || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    void checkout(rootUrl() + 'checkout');
  }, true);
  document.addEventListener('cart:refresh', event => {
    if (event.detail?.source === 'tm-offer-reservation') { render(); return; }
    if (!acceptCart(event.detail?.cart)) invalidateCart();
    render(); schedule();
  });
  const resume = () => {
    if (session || Number(cart?.item_count)) void ensureSession({ refresh: true });
    render(); schedule();
  };
  window.addEventListener('pageshow', resume);
  window.addEventListener('storage', event => {
    if (event.key === NATIVE_KEY || event.key === WHEEL_KEY || event.key === HERITAGE_KEY) { session = null; deadlineRefreshed = 0; resume(); }
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resume();
  });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(ROOT + ', [data-tm-cart-summary]') || node.querySelector?.(ROOT + ', [data-tm-cart-summary]'))))) { invalidateCart(); render(); schedule(); }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(() => {
    render();
    const deadline = session?.state === 'claimed' && (session.offer?.kind === 'discount' || session.offer?.browserTimed === true) ? session.offer.expiresAt
      : session?.state === 'available' ? session.expiresAt : 0;
    if (session?.state === 'expired' && canReactivate(session.offer)) void ensureSession({ refresh: true });
    if (serviceReady && deadline && deadline <= now() && deadlineRefreshed !== deadline) {
      deadlineRefreshed = deadline;
      void ensureSession({ refresh: true });
      void window.TMWheelCart?.cleanupExpiredOffer?.()?.catch?.(() => {});
      schedule();
    }
  }, 1000);
  bindCart();
  [500, 1500].forEach(delay => window.setTimeout(bindCart, delay));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { bindCart(); sync(); }, { once: true });
  else sync();
})();
